/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
import * as React from "react"
import Svg from "@oui/system/Svg"
type DefaultProps = typeof defaultProps
type SvgProps = React.ComponentPropsWithoutRef<typeof Svg>
type Props = DefaultProps &
  Omit<SvgProps, "fill" | "height" | "stroke" | "viewBox" | "width">
const defaultProps = {
  label: "Desktop",
  size: 20
}

const SvgDesktop = ({ size, ...props }: Props) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="currentcolor"
    stroke="currentcolor"
    {...props}
  >
    <path d="M8 15h1v2H8zM11 15h1v2h-1z" />
    <path d="M5 16h10v1H5z" />
    <path fill="none" d="M1.5 3.5h17v11h-17z" />
  </Svg>
)

SvgDesktop.defaultProps = defaultProps
export default SvgDesktop
